import React, { FC } from 'react';
import { NotSyncedWithEtrProps } from './NotSyncedWithETRProps';
import InlineMessage from '@ingka/inline-message';
import { Stack } from '@mui/material';
import useTranslation from '../../hooks/useTranslation';
import { projectFromReltp } from '../../utils/fieldEditingRules';

const NotSyncedWithEtr: FC<NotSyncedWithEtrProps> = ({ synced, source }) => {
  const t = useTranslation();
  return (
    !synced &&
    projectFromReltp(source) && (
      <Stack p={2}>
        <InlineMessage
          body={t('projects.notSyncedWithEtrMessage')}
          variant={'negative'}
        />
      </Stack>
    )
  );
};

export default NotSyncedWithEtr;
